import { render, staticRenderFns } from "./QuickTipsRetireMergeId.vue?vue&type=template&id=d2ccb850&scoped=true&"
import script from "./QuickTipsRetireMergeId.vue?vue&type=script&lang=js&"
export * from "./QuickTipsRetireMergeId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ccb850",
  null
  
)

export default component.exports